import React from 'react';

const CaseContext = React.createContext([]);

export default CaseContext;
